import React from 'react';
import * as PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import OptionCardIcon from './atoms/OptionCardIcon';
import OptionCardControl from './atoms/OptionCardControl';

const normalButtonStyles = 'text-slate-800 hover:shadow-sm';
const disabledButtonStyles = 'border text-slate-300 border-slate-200';

const normalLabelStyles = 'cursor-pointer';
const disabledLabelStyles = 'cursor-not-allowed';

const OptionCard = ({
  children,
  value,
  isSelected,
  variantStyles,
  labelName,
  selectedStyles,
  isDisabled,
  onChange,
  iconName,
}) => {
  const buttonClasses = useClassNames(
    () => [
      'rounded',
      'font-semibold',
      'focus:outline-none',
      'w-full',
      'mb-3',
      isDisabled && disabledButtonStyles,
      !isDisabled && isSelected && selectedStyles,
      !isDisabled && normalButtonStyles,
      !isDisabled && variantStyles,
    ],
    [variantStyles, isDisabled, isSelected, selectedStyles],
  );

  const labelClasses = useClassNames(
    () => [
      'px-6',
      'block',
      iconName ? 'py-2' : 'py-4',
      isDisabled && disabledLabelStyles,
      !isDisabled && normalLabelStyles,
    ],
    [isDisabled],
  );

  return (
    <button
      type="button"
      className={buttonClasses}
      onClick={checked => !isDisabled && onChange(value, checked.target.checked)}
    >
      <label className={labelClasses} htmlFor={labelName}>
        {children}
      </label>
    </button>
  );
};

OptionCard.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.any.isRequired,
  labelName: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  variantStyles: PropTypes.string,
  selectedStyles: PropTypes.string,
  onChange: PropTypes.func,
  iconName: PropTypes.string,
};

OptionCard.Icon = OptionCardIcon;
OptionCard.Control = OptionCardControl;

export default OptionCard;
